import TagDeleteModal from './tag-delete-modal';

export default TagDeleteModal;
